// extracted by mini-css-extract-plugin
module.exports = {"btn":"Index_btn__ajgT7","tt":"Index_tt__xU3Nz"};